import { IconButton } from '@wix/design-system';
import { Dismiss } from '@wix/wix-ui-icons-common';
import { LayoutTwoThirds } from '@wix/wix-ui-icons-common/odeditor';
import classNames from 'classnames';
import React, { FC } from 'react';

import { useIsCopilotRedesign } from '../../../common/hooks/useIsCopilotRedesign';
import { dismissCopilot } from '../../../messageChannel/postNewMessages';
import { renderModel } from '../../../util/renderModel';
import css from './styles.scss';

const isCopilot = renderModel.isCopilot();

export const CancelButton: FC<{}> = (props) => {
  const isArticlePageRedesign = useIsCopilotRedesign();

  if (isArticlePageRedesign) {
    return (
      <IconButton size="small" skin="dark" priority="secondary" onClick={dismissCopilot}>
        <LayoutTwoThirds />
      </IconButton>
    );
  }

  return (
    <Dismiss
      onClick={dismissCopilot}
      className={classNames(css.cancelButton, { [css.copilot]: isCopilot })}
    />
  );
};
